import http from '../index'

export default {
	// 系统
	sys: {
		getDepartmentList: data => http.get(`/stroke/v1/patientinquiry/getDepartmentList`, data)
	},
	// 账号相关接口
	account: {
		// 发送短信验证码
		sendSmsCode: (phone, options, type) =>
			http.get(`/api/v1/smsrecord/sendSmsCode`, { phone, type: type ? type : 3 }, options),
		// 用户根据手机号和验证码登录,未注册手机号会直接注册待完善资料
		valCodeAndPhone: (data, options) => http.post(`/api/v1/patientaccount/valCodeAndPhone`, data, options),
		// 获取微信头像和昵称
		getWechatInfo: () => http.get(`/api/v1/patientaccount/getWechatInfo`),
		// 退出登录
		logout: () => http.post(`/api/v1/patientaccount/logout`),
		// 获取毫秒级别时间戳
		getDateTime: () => http.get(`/api/wxoauth/getDateTime`),
		// 获取jsconfig信息
		wxGetConfig: data => http.post(`/api/wxoauth/getJsconfig`, data),
		// 获取微信素材
		getMediaFile: id => http.get(`/api/v1/patient/getMediaFile/${id}`),
		// 获取资讯详情
		getInfoByCode: code => http.get(`/stroke/v1/agreement/getInfoByCode/${code}`)
	},
	// 医生相关接口
	doctor: {
		getDoctorInfoById: id => http.get(`/api/v1/doctoraccount/getDoctorInfoById/${id}`),
		// 获取患者绑定医生的科室数据
		getBindDepartmentData: id => http.get(`/api/v1/patientaccount/getBindDepartmentData/${id}`),
		// 首页检测是否弹出科室弹窗
		checkDepartmentDialog: id => http.get(`/stroke/v1/openpagerecord/getOpenPageStatus/${id}`),
		//加入团队
		joinTeamWeb: data => http.post(`/stroke/team/joinTeamWeb`, data),
		//团队详情
		getTeamDetail: id => http.get(`/stroke/team/info/${id}`),
		//团队详情
		getTeamDetailNoToken: id => http.get(`/stroke/team/teamInfo/${id}`),
		//获取医生列表
		getDoctorList: data => http.get(`/stroke/v1/patientinquiry/getDoctorList`, data, { noToast: true })
	},
	// 患者相关接口
	patient: {
		// 获取患者详情
		getPatientInfo: id => http.get(`/api/v1/patientaccount/getPatientInfo/${id}`),
		// 获取患者详情By 医生
		getPatientInfoByDoctor: id => http.get(`/api/v1/patientaccount/getPatientInfoNoToken/${id}`),
		// 切换展示患者
		switchPatient: id => http.get(`/api/v1/patientaccount/switchPatient/${id}`),
		// 获取患者相关数据
		getPatientRelatedData: id => http.get(`/api/v1/patientaccount/getPatientRelatedData/${id}`),
		// 新增患者绑定医生
		savePatientBindDoctor: data => http.post(`/api/v1/patientaccount/savePatientBindDoctor`, data),
		// 获取患者列表
		getPatientList: data => http.get(`/api/v1/patientaccount/getPatientList`, data),
		// 获取邀请共管二维码
		getInvitationQrCode: id => http.get(`/api/v1/patient/getInvitationQrCode/${id}`),
		// 查看当前患者与账号是否绑定
		getPatientStatusByApplyId: id => http.get(`/stroke/v1/commonpipeapply/getPatientStatusByApplyId/${id}`),
		// 根据共管id获取当前共管状态
		geApplyStatusByApplyId: id => http.get(`/stroke/v1/commonpipeapply/geApplyStatusByApplyId/${id}`),
		// 申请共管
		applyCommonPipe: data => http.post(`/stroke/v1/commonpipeapply/applyCommonPipe`, data),
		// 共管审核
		auditCommonPipe: data => http.post(`/stroke/v1/commonpipeapply/auditCommonPipe`, data),
		// 患者信息修改
		updatePatient: data => http.post(`/api/v1/patient/updatePatient`, data),
		// 新增用药信息
		saveMedication: data => http.post(`/stroke/v1/patientmedication/saveMedication`, data),
		// 根据患者id获取用药信息
		getMedicationByPatientId: id => http.get(`/stroke/v1/patientmedication/getMedicationByPatientId/${id}`),
		// 上传就医记录
		saveHospitalVisit: data => http.post(`/stroke/v1/patienthospitalvisit/saveHospitalVisit`, data),
		// 修改就医记录
		updateHospitalVisit: data => http.post(`/stroke/v1/patienthospitalvisit/updateHospitalVisit`, data),
		// 就医记录分页
		getHospitalVisit: data => http.get(`/stroke/v1/patienthospitalvisit/page`, data),
		// 就医记录详情
		getHospitalVisitDetail: id => http.get(`/stroke/v1/patienthospitalvisit/${id}`),
		// 新增检查
		saveInspection: data => http.post(`/stroke/v1/patientinspection/saveInspection`, data),
		// 修改检查
		updateInspection: data => http.post(`/stroke/v1/patientinspection/updateInspection`, data),
		// 检查分页
		getInspection: data => http.get(`/stroke/v1/patientinspection/page`, data),
		// 检查详情
		getInspectionDetail: id => http.get(`/stroke/v1/patientinspection/${id}`),
		// 新增体检记录
		savePhysical: data => http.post(`/stroke/v1/patientphysicalexamination/savePhysicalExamination`, data),
		// 修改体检记录
		updatePhysical: data => http.post(`/stroke/v1/patientphysicalexamination/updatePhysicalExamination`, data),
		// 体检记录分页
		getPhysical: data => http.get(`/stroke/v1/patientphysicalexamination/page`, data),
		// 体检记录详情
		getPhysicalDetail: id => http.get(`/stroke/v1/patientphysicalexamination/${id}`),
		//科室弹窗状态设置为已读
		setDepartmentStatus: id => http.post('/stroke/v1/openpagerecord', { patientId: id }),
		//获取患用药列表
		getRemindList: data => http.get(`/stroke/scpatientmedicationreminde/page`, data),
		//新增用药提醒
		addRemind: data => http.post(`/stroke/scpatientmedicationreminde`, data),
		//修改用药提醒
		updateRemind: data => http.post(`/stroke/scpatientmedicationreminde/update`, data),
		//获取用药提醒
		getRemindDetail: id => http.get(`/stroke/scpatientmedicationreminde/${id}`),
		//删除用药提醒
		deleteRemind: id => http.post(`/stroke/scpatientmedicationreminde/delete`, [id]),
		//获取用药记录
		getPatientMedicationRecord: data => http.post(`/stroke/v1/patientmedication/getPatientMedicationRecord`, data),
		//获取服药详情
		patientmedicationreminderDetail: id => http.get(`/stroke/v1/patientmedicationreminder/${id}`),
		//修改状态
		patientmedicationreminderUpdate: data =>
			http.post(`/stroke/scpatientmedicationrecord/updateReminderStatus`, data),
		//用药记录
		getRemindLogList: data => http.get(`/stroke/scpatientmedicationrecord/page`, data),
		//获取大麦表单详情
		getFormDetail: id => http.get(`stroke/v1/questionanswer/getYuTangQuestionInfo/${id}`),
		//获取随访模版表单详情
		getFormDetailByFollow: id => http.get(`/stroke/questionnaire/${id}`),
		//扫码保存
		saveFormByQrcode: data => http.post(`stroke/v1/questionanswer/submitQuestionAnswer`, data),
		//获取群发消息
		getMessageList: data => http.get(`/stroke/scmassmessagingpatient/page`, data),
		//查看详情
		getMessageDetail: id => http.get(`/stroke/scmassmessagingpatient/${id}`),
		// 获取群发消息未读
		getNotReadeNumber: data => http.post(`/stroke/scmassmessagingpatient/list`, data),
		//修改消息状态
		updateMessage: data => http.post(`/stroke/scmassmessagingpatient/updateReadStatus`, data),
		//获取就诊人剩余咨询次数
		getServiceUsableNumber: data => http.get(`/stroke/servicesuborder/getServiceUsableNumber/${data.id}`),
		//获取开始的咨询列表
		getStartConsult: data => http.get(`/stroke/v1/patientinquiry/getStartConsult/${data.id}`)
	},
	// 预约问诊
	physicianVisits: {
		// 获取医生诊断
		getDoctorDiagnosis: id => http.get(`stroke/v1/patientinquiry/getDoctorDiagnosis/${id}`),
		// 获取服务记录
		getConsultRecordPage: data => http.get(`stroke/v1/patientinquiry/getConsultRecordPage`, data),
		// 获取医生两周的预约状态
		getDoctorAppointmentStatus: data => http.get(`/stroke/v1/patientinquiry/getDoctorAppointmentStatus`, data),
		// 获取预约详情
		getAppointmentInfo: id => http.get(`/stroke/v1/doctoradmissions/getAppointmentInfo/${id}`),
		// 预约医生
		appointmentDoctor: data => http.post(`/stroke/v1/patientinquiry/appointmentDoctor`, data),
		// 填写问诊主诉
		saveInquiryChief: data => http.post(`/stroke/v1/patientinquiry/saveInquiryChief`, data),
		// 根据日期获取可以预约的医生
		getAppointmentDoctorListByDate: data =>
			http.get(`/stroke/v1/patientinquiry/getAppointmentDoctorListByDate`, data),
		//根据时间获取医生列表
		getDoctorsByDate: data => http.get(`/stroke/v1/patientinquiry/getDoctorsByDate`, data)
	},
	information: {
		// 科普分页
		page: data => http.get(`/stroke/popularscience/page`, data),
		// 科普详情
		detail: data => http.get(`/stroke/popularscience/getInfo`, data),
		// 获取未读文章数
		getUnreadNum: data => http.get(`stroke/popularscience/getUnreadNum/${data.patientId}`),
		//动作库
		getActionlibrary: data => http.get(`/stroke/actionlibrary/page`, data),
		//动作库-详情
		getActionlibraryDetail: data => http.get(`/stroke/actionlibrary/${data.id}`, {})
	},
	indicator: {
		// 保存血压记录
		saveBloodPressureRecord: data => http.post(`/stroke/v1/bloodpressure/saveBloodPressureRecord`, data),
		// 修改血压记录
		updateBloodPressureRecord: data => http.post(`/stroke/v1/bloodpressure/updateBloodPressureRecord`, data),
		// 详情血压记录
		bloodpressureDetail: id => http.get(`/stroke/v1/bloodpressure/${id}`),
		// 分页血压记录
		bloodpressurePage: data => http.get(`/stroke/v1/bloodpressure/page`, data),
		// 删除血压记录
		bloodpressureDelete: data => http.post(`/stroke/v1/bloodpressure`, data),
		// 获取最近时间的血压记录
		bloodPressureLastInfo: data => http.get(`/stroke/v1/bloodpressure/getBloodPressureList`, data),
		//获取血压图表数据
		getBloodpressureCharts: data => http.post(`/stroke/v1/bloodpressure/getBloodPressureTrends`, data),

		// 保存血糖记录
		saveBloodSugarRecord: data => http.post(`/stroke/v1/bloodsugarrecord/saveBloodSugarRecord`, data),
		// 修改血糖记录
		updateBloodSugarRecord: data => http.post(`/stroke/v1/bloodsugarrecord/updateBloodSugarRecord`, data),
		// 详情血糖记录
		bloodSugarDetail: id => http.get(`/stroke/v1/bloodsugarrecord/${id}`),
		// 分页血糖记录
		bloodSugarPage: data => http.get(`/stroke/v1/bloodsugarrecord/page`, data),
		// 删除血糖记录
		bloodSugarDelete: data => http.post(`/stroke/v1/bloodsugarrecord`, data),
		// 获取最近时间的血糖记录
		bloodSugarLastInfo: data => http.get(`/stroke/v1/bloodsugarrecord/getBloodSugarList`, data),
		//获取血糖图表数据
		getBloodsugarCharts: data => http.post(`/stroke/v1/bloodsugarrecord/getBloodPressureTrends`, data),

		// 保存血脂记录
		saveBloodFatRecord: data => http.post(`/stroke/v1/bloodlipidsrecord/saveBloodLipidsRecord`, data),
		// 修改血脂记录
		updateBloodFatRecord: data => http.post(`/stroke/v1/bloodlipidsrecord/updateBloodLipidsRecord`, data),
		// 详情血脂记录
		bloodFatDetail: id => http.get(`/stroke/v1/bloodlipidsrecord/${id}`),
		// 分页血脂记录
		bloodFatPage: data => http.get(`/stroke/v1/bloodlipidsrecord/page`, data),
		// 删除血脂记录
		bloodFatDelete: data => http.post(`/stroke/v1/bloodlipidsrecord`, data),
		// 获取最近时间的血脂记录
		bloodFatLastInfo: data => http.get(`/stroke/v1/bloodlipidsrecord/getLastBloodLipidsInfo`, data),
		// 保存随访
		updateQuestionAnswer: data => http.post(`/stroke/v1/questionanswer/updateQuestionAnswer`, data)
	},
	servicePack: {
		// 获取服务包列表
		getList: data => http.get(`stroke/servicepkg/page`, data),
		// 获取服务详情
		getDetail: data => http.get(`/stroke/servicepkg/getServicePkgInfo/${data.id}`, data),
		// 医生端获取服务包详情
		getDetailByDoctor: data => http.get(`/stroke/servicepkg/getServicePkgInfo/${data.id}`),
		// 获取服务包下的服务项详情
		getChildDetail: data => http.get(`/stroke/v1/departmentservice/getServiceGoodInfo`, data),
		//生成服务记录
		patientCreateServiceRecord: data => http.post(`/api/v1/doctorpatient/patientCreateServiceRecord`, data),
		// 服务记录详情
		getPakRecordInfo: data => http.get(`/stroke/scservicepkgrecord/getPakRecordInfo/${data.id} `)
	},
	order: {
		// 获取服务包订单列表
		getServiceList: data => http.get(`/stroke/v1/serviceorder/page`, data),
		// 获取服务包订单详情
		getServiceDetail: id => http.get(`/stroke/v1/serviceorder/info/${id}`),
		// 删除服务包订单
		deleteService: id => http.post(`/stroke/v1/serviceorder/deleteOrder/${id}`),
		//咨询订单列表
		getConsultList: data => http.get(`/stroke/scconsultorder/page`, data),
		//咨询订单详情
		getConsultDetail: data => http.get(`/stroke/scconsultorder/${data.id}`)
	},
	pay: {
		// 创建订单
		createOrder: data => http.post(`/stroke/scconsultorder/createConsultOrder`, data),
		// 创建服务包的订单
		createServiceOrder: data => http.post(`/stroke/v1/serviceorder/createOrder`, data),
		// 微信预下单接口
		wxPayOrder: data => http.post(`/stroke/v1/serviceorder/preOrder`, data),
		// 微信支付成功回调
		wxPaySuccess: data => http.post(`/stroke/v1/serviceorder/wechatNotify`, data),
		// 获取物流信息
		getLogisticsRecord: id => http.get(`/stroke/v1/serviceorder/getLogisticsRecord/${id}`),
		//咨询订单再次支付
		continuePayment: data => http.post(`/stroke/scconsultorder/continuePayment`, data)
	},
	address: {
		// 省市区
		regionTree: data => http.get(`/sys/region/region`, data),
		// 收货地址分页
		page: data => http.get(`/stroke/patientdeliveryaddress/page`, data),
		// 创建收货地址
		create: data => http.post(`/stroke/patientdeliveryaddress`, data),
		// 编辑收货地址
		update: data => http.post(`/stroke/patientdeliveryaddress/update`, data),
		// 删除收货地址
		delete: data => http.post(`/stroke/patientdeliveryaddress/delete`, data),
		// 查看收货地址
		detail: id => http.get(`/stroke/patientdeliveryaddress/${id}`)
	},
	task: {
		// 获取未完成任务
		getNoCompleteTask: data => http.get(`/stroke/v1/patienttask/getPatientNoCompleteTaskList`, data),
		// 根据日期获取任务列表
		getTaskList: data => http.get(`/stroke/v1/patienttask/getPatientTaskListByDate`, data),
		// 修改任务状态
		changeTaskState: data => http.post(`/stroke/v1/patienttask/updateReminderStatus`, data)
	},
	risk: {
		// 保存风险评估
		setPatientriskquestionnaire: data => http.post(`/stroke/v1/patientriskquestionnaire`, data),
		getPatientriskquestionnaire: id => http.get(`/stroke/v1/patientriskquestionnaire/getRiskInfo/${id}`)
		// ceshi:data=>http.post(`http://sr65424726.zicp.fun/quickIookup/queryXlmcAndId`,data)
	},
	followUp: {
		// 获取随访列表
		getFollowUpList: data => http.get(`/stroke/v1/questionanswer/page`, data),
		addFollowUp: data => http.post(`/stroke/v1/questionanswer/writeQuestionAnswer`, data),
		getFollowUpDetail: id => http.get(`/stroke/v1/questionanswer/getInfo`, { id }),
		getInfoNoToken: id => http.get(`/stroke/v1/questionanswer/getInfoNoToken`, { id }),
		getFollowUpNewDate: data => http.post(`/stroke/v1/questionanswer/getMinShow`, data)
	},
	report: {
		getReportList: data => http.get('/stroke/patientreport/page', data),
		getReportDetail: id => http.get(`/stroke/patientreport/${id}`)
	},
	plan: {
		getDataList: data => http.get(`/stroke/patientfurtherconsultation/list/${data.patientId}`),
		update: data => http.post(`/stroke/patientfurtherconsultation/confirm`, data)
	}
}
